/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgendaAttachmentRead } from '../models/AgendaAttachmentRead';
import type { AgendaItemCreate } from '../models/AgendaItemCreate';
import type { AgendaItemRead } from '../models/AgendaItemRead';
import type { AgendaItemUpdate } from '../models/AgendaItemUpdate';
import type { AgendaReorder } from '../models/AgendaReorder';
import type { AnnotationCreate } from '../models/AnnotationCreate';
import type { AnnotationRead } from '../models/AnnotationRead';
import type { AnnotationShare } from '../models/AnnotationShare';
import type { BallotCreate } from '../models/BallotCreate';
import type { BallotRead } from '../models/BallotRead';
import type { Body_upload_agenda_attachment_boardbacks__pack_id__agenda__item_id__attachments_upload_post } from '../models/Body_upload_agenda_attachment_boardbacks__pack_id__agenda__item_id__attachments_upload_post';
import type { Body_upload_document_boardbacks_sections__section_id__documents_upload_post } from '../models/Body_upload_document_boardbacks_sections__section_id__documents_upload_post';
import type { DocumentCreate } from '../models/DocumentCreate';
import type { DocumentRead } from '../models/DocumentRead';
import type { MotionCreate } from '../models/MotionCreate';
import type { MotionRead } from '../models/MotionRead';
import type { PackCreate } from '../models/PackCreate';
import type { PackRead } from '../models/PackRead';
import type { PackUpdate } from '../models/PackUpdate';
import type { QuestionCreate } from '../models/QuestionCreate';
import type { QuestionMessageCreate } from '../models/QuestionMessageCreate';
import type { QuestionRead } from '../models/QuestionRead';
import type { SectionCreate } from '../models/SectionCreate';
import type { SectionRead } from '../models/SectionRead';
import type { SectionUpdate } from '../models/SectionUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BoardBacksService {
    /**
     * List Packs
     * @returns PackRead Successful Response
     * @throws ApiError
     */
    public static listPacksBoardbacksGet(): CancelablePromise<Array<PackRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/boardbacks',
        });
    }
    /**
     * Create Pack
     * @returns PackRead Successful Response
     * @throws ApiError
     */
    public static createPackBoardbacksPost({
        requestBody,
    }: {
        requestBody: PackCreate,
    }): CancelablePromise<PackRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Pack
     * @returns PackRead Successful Response
     * @throws ApiError
     */
    public static getPackBoardbacksPackIdGet({
        packId,
    }: {
        packId: number,
    }): CancelablePromise<PackRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/boardbacks/{pack_id}',
            path: {
                'pack_id': packId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Pack
     * @returns PackRead Successful Response
     * @throws ApiError
     */
    public static updatePackBoardbacksPackIdPut({
        packId,
        requestBody,
    }: {
        packId: number,
        requestBody: PackUpdate,
    }): CancelablePromise<PackRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/boardbacks/{pack_id}',
            path: {
                'pack_id': packId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Publish Pack
     * @returns PackRead Successful Response
     * @throws ApiError
     */
    public static publishPackBoardbacksPackIdPublishPost({
        packId,
    }: {
        packId: number,
    }): CancelablePromise<PackRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/{pack_id}/publish',
            path: {
                'pack_id': packId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Section
     * @returns SectionRead Successful Response
     * @throws ApiError
     */
    public static addSectionBoardbacksPackIdSectionsPost({
        packId,
        requestBody,
    }: {
        packId: number,
        requestBody: SectionCreate,
    }): CancelablePromise<SectionRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/{pack_id}/sections',
            path: {
                'pack_id': packId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Section
     * @returns SectionRead Successful Response
     * @throws ApiError
     */
    public static updateSectionBoardbacksSectionsSectionIdPut({
        sectionId,
        requestBody,
    }: {
        sectionId: number,
        requestBody: SectionUpdate,
    }): CancelablePromise<SectionRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/boardbacks/sections/{section_id}',
            path: {
                'section_id': sectionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Agenda Items
     * @returns AgendaItemRead Successful Response
     * @throws ApiError
     */
    public static listAgendaItemsBoardbacksPackIdAgendaGet({
        packId,
    }: {
        packId: number,
    }): CancelablePromise<Array<AgendaItemRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/boardbacks/{pack_id}/agenda',
            path: {
                'pack_id': packId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Agenda Item
     * @returns AgendaItemRead Successful Response
     * @throws ApiError
     */
    public static createAgendaItemBoardbacksPackIdAgendaPost({
        packId,
        requestBody,
    }: {
        packId: number,
        requestBody: AgendaItemCreate,
    }): CancelablePromise<AgendaItemRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/{pack_id}/agenda',
            path: {
                'pack_id': packId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Agenda Item
     * @returns AgendaItemRead Successful Response
     * @throws ApiError
     */
    public static updateAgendaItemBoardbacksPackIdAgendaItemIdPut({
        packId,
        itemId,
        requestBody,
    }: {
        packId: number,
        itemId: number,
        requestBody: AgendaItemUpdate,
    }): CancelablePromise<AgendaItemRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/boardbacks/{pack_id}/agenda/{item_id}',
            path: {
                'pack_id': packId,
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Agenda Item
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteAgendaItemBoardbacksPackIdAgendaItemIdDelete({
        packId,
        itemId,
    }: {
        packId: number,
        itemId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/boardbacks/{pack_id}/agenda/{item_id}',
            path: {
                'pack_id': packId,
                'item_id': itemId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reorder Agenda Items
     * @returns AgendaItemRead Successful Response
     * @throws ApiError
     */
    public static reorderAgendaItemsBoardbacksPackIdAgendaReorderPost({
        packId,
        requestBody,
    }: {
        packId: number,
        requestBody: AgendaReorder,
    }): CancelablePromise<Array<AgendaItemRead>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/{pack_id}/agenda/reorder',
            path: {
                'pack_id': packId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Agenda Attachment
     * @returns AgendaAttachmentRead Successful Response
     * @throws ApiError
     */
    public static uploadAgendaAttachmentBoardbacksPackIdAgendaItemIdAttachmentsUploadPost({
        packId,
        itemId,
        formData,
    }: {
        packId: number,
        itemId: number,
        formData: Body_upload_agenda_attachment_boardbacks__pack_id__agenda__item_id__attachments_upload_post,
    }): CancelablePromise<AgendaAttachmentRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/{pack_id}/agenda/{item_id}/attachments/upload',
            path: {
                'pack_id': packId,
                'item_id': itemId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Agenda Attachment
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteAgendaAttachmentBoardbacksPackIdAgendaAttachmentsAttachmentIdDelete({
        packId,
        attachmentId,
    }: {
        packId: number,
        attachmentId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/boardbacks/{pack_id}/agenda/attachments/{attachment_id}',
            path: {
                'pack_id': packId,
                'attachment_id': attachmentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Download Agenda Attachment
     * @returns any Successful Response
     * @throws ApiError
     */
    public static downloadAgendaAttachmentBoardbacksPackIdAgendaAttachmentsAttachmentIdFileGet({
        packId,
        attachmentId,
    }: {
        packId: number,
        attachmentId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/boardbacks/{pack_id}/agenda/attachments/{attachment_id}/file',
            path: {
                'pack_id': packId,
                'attachment_id': attachmentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Document To Section
     * @returns DocumentRead Successful Response
     * @throws ApiError
     */
    public static addDocumentToSectionBoardbacksSectionsSectionIdDocumentsPost({
        sectionId,
        requestBody,
    }: {
        sectionId: number,
        requestBody: DocumentCreate,
    }): CancelablePromise<DocumentRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/sections/{section_id}/documents',
            path: {
                'section_id': sectionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Document
     * @returns DocumentRead Successful Response
     * @throws ApiError
     */
    public static uploadDocumentBoardbacksSectionsSectionIdDocumentsUploadPost({
        sectionId,
        formData,
    }: {
        sectionId: number,
        formData: Body_upload_document_boardbacks_sections__section_id__documents_upload_post,
    }): CancelablePromise<DocumentRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/sections/{section_id}/documents/upload',
            path: {
                'section_id': sectionId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Document Without Section
     * @returns DocumentRead Successful Response
     * @throws ApiError
     */
    public static addDocumentWithoutSectionBoardbacksPackIdSectionsDocumentsPost({
        packId,
        requestBody,
    }: {
        packId: number,
        requestBody: DocumentCreate,
    }): CancelablePromise<DocumentRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/{pack_id}/sections/documents',
            path: {
                'pack_id': packId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Annotations
     * @returns AnnotationRead Successful Response
     * @throws ApiError
     */
    public static listAnnotationsBoardbacksDocumentsDocumentIdAnnotationsGet({
        documentId,
        includePrivate = false,
    }: {
        documentId: number,
        includePrivate?: boolean,
    }): CancelablePromise<Array<AnnotationRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/boardbacks/documents/{document_id}/annotations',
            path: {
                'document_id': documentId,
            },
            query: {
                'include_private': includePrivate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Annotation
     * @returns AnnotationRead Successful Response
     * @throws ApiError
     */
    public static createAnnotationBoardbacksDocumentsDocumentIdAnnotationsPost({
        documentId,
        requestBody,
    }: {
        documentId: number,
        requestBody: AnnotationCreate,
    }): CancelablePromise<AnnotationRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/documents/{document_id}/annotations',
            path: {
                'document_id': documentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Attachment Annotations
     * @returns AnnotationRead Successful Response
     * @throws ApiError
     */
    public static listAttachmentAnnotationsBoardbacksAgendaAttachmentsAttachmentIdAnnotationsGet({
        attachmentId,
        includePrivate = false,
    }: {
        attachmentId: number,
        includePrivate?: boolean,
    }): CancelablePromise<Array<AnnotationRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/boardbacks/agenda/attachments/{attachment_id}/annotations',
            path: {
                'attachment_id': attachmentId,
            },
            query: {
                'include_private': includePrivate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Attachment Annotation
     * @returns AnnotationRead Successful Response
     * @throws ApiError
     */
    public static createAttachmentAnnotationBoardbacksAgendaAttachmentsAttachmentIdAnnotationsPost({
        attachmentId,
        requestBody,
    }: {
        attachmentId: number,
        requestBody: AnnotationCreate,
    }): CancelablePromise<AnnotationRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/agenda/attachments/{attachment_id}/annotations',
            path: {
                'attachment_id': attachmentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Document
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteDocumentBoardbacksDocumentsDocumentIdDelete({
        documentId,
    }: {
        documentId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/boardbacks/documents/{document_id}',
            path: {
                'document_id': documentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Share Annotation
     * @returns AnnotationRead Successful Response
     * @throws ApiError
     */
    public static shareAnnotationBoardbacksAnnotationsAnnotationIdSharePost({
        annotationId,
        requestBody,
    }: {
        annotationId: number,
        requestBody: AnnotationShare,
    }): CancelablePromise<AnnotationRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/annotations/{annotation_id}/share',
            path: {
                'annotation_id': annotationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Questions
     * @returns QuestionRead Successful Response
     * @throws ApiError
     */
    public static listQuestionsBoardbacksPackIdQuestionsGet({
        packId,
    }: {
        packId: number,
    }): CancelablePromise<Array<QuestionRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/boardbacks/{pack_id}/questions',
            path: {
                'pack_id': packId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Question
     * @returns QuestionRead Successful Response
     * @throws ApiError
     */
    public static createQuestionBoardbacksPackIdQuestionsPost({
        packId,
        requestBody,
    }: {
        packId: number,
        requestBody: QuestionCreate,
    }): CancelablePromise<QuestionRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/{pack_id}/questions',
            path: {
                'pack_id': packId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Question Message
     * @returns QuestionRead Successful Response
     * @throws ApiError
     */
    public static addQuestionMessageBoardbacksQuestionsQuestionIdMessagesPost({
        questionId,
        requestBody,
    }: {
        questionId: number,
        requestBody: QuestionMessageCreate,
    }): CancelablePromise<QuestionRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/questions/{question_id}/messages',
            path: {
                'question_id': questionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Resolve Question
     * @returns QuestionRead Successful Response
     * @throws ApiError
     */
    public static resolveQuestionBoardbacksQuestionsQuestionIdResolvePost({
        questionId,
    }: {
        questionId: number,
    }): CancelablePromise<QuestionRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/questions/{question_id}/resolve',
            path: {
                'question_id': questionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Motion
     * @returns MotionRead Successful Response
     * @throws ApiError
     */
    public static createMotionBoardbacksPackIdMotionsPost({
        packId,
        requestBody,
    }: {
        packId: number,
        requestBody: MotionCreate,
    }): CancelablePromise<MotionRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/{pack_id}/motions',
            path: {
                'pack_id': packId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Cast Ballot
     * @returns BallotRead Successful Response
     * @throws ApiError
     */
    public static castBallotBoardbacksMotionsMotionIdBallotsPost({
        motionId,
        requestBody,
    }: {
        motionId: number,
        requestBody: BallotCreate,
    }): CancelablePromise<BallotRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/motions/{motion_id}/ballots',
            path: {
                'motion_id': motionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Close Motion
     * @returns MotionRead Successful Response
     * @throws ApiError
     */
    public static closeMotionBoardbacksMotionsMotionIdClosePost({
        motionId,
    }: {
        motionId: number,
    }): CancelablePromise<MotionRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/motions/{motion_id}/close',
            path: {
                'motion_id': motionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Export
     * @returns any Successful Response
     * @throws ApiError
     */
    public static startExportBoardbacksPackIdExportPost({
        packId,
    }: {
        packId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/{pack_id}/export',
            path: {
                'pack_id': packId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Export Status
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getExportStatusBoardbacksExportsExportIdStatusGet({
        exportId,
    }: {
        exportId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/boardbacks/exports/{export_id}/status',
            path: {
                'export_id': exportId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Download Export
     * @returns any Successful Response
     * @throws ApiError
     */
    public static downloadExportBoardbacksExportsExportIdDownloadGet({
        exportId,
    }: {
        exportId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/boardbacks/exports/{export_id}/download',
            path: {
                'export_id': exportId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Meeting
     * @returns any Successful Response
     * @throws ApiError
     */
    public static startMeetingBoardbacksPackIdMeetingStartPost({
        packId,
    }: {
        packId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/{pack_id}/meeting/start',
            path: {
                'pack_id': packId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Meeting State
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateMeetingStateBoardbacksMeetingSessionIdStatePost({
        sessionId,
        requestBody,
    }: {
        sessionId: number,
        requestBody: Record<string, any>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/meeting/{session_id}/state',
            path: {
                'session_id': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * End Meeting
     * @returns any Successful Response
     * @throws ApiError
     */
    public static endMeetingBoardbacksMeetingSessionIdEndPost({
        sessionId,
    }: {
        sessionId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/boardbacks/meeting/{session_id}/end',
            path: {
                'session_id': sessionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Download Document
     * @returns any Successful Response
     * @throws ApiError
     */
    public static downloadDocumentBoardbacksDocumentsDocumentIdFileGet({
        documentId,
    }: {
        documentId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/boardbacks/documents/{document_id}/file',
            path: {
                'document_id': documentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
